module.exports = __webpack_public_path__ + "static/media/12a Belt Grip.e541fabe.jpg";